import SignupPage from './pages/signup-page/SignupPage';
import ConfirmPage from './pages/confirm-page/ConfirmPage';
import LoginPage from './pages/login-page/LoginPage';
// import HomePage from './pages/home-page/HomePage';
import ProtectedRoute from './routes/ProtectedRoute';
import AuthRoute from './routes/AuthRoute';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ChatArtifactProvider } from './contexts/ChatArtifactContext';
import { cn } from './lib/utils';
import MainLayout from './layouts/MainLayout';
import ChatPage from './pages/chat-page/ChatPage';
import PluginsPage from './pages/plugins-page/PluginsPage';
import ChannelsPage from './pages/channels-page/ChannelsPage';
import GoogleCallback from './pages/auth/google_callback';
import MetaCallback from './pages/auth/meta_callback';
import LinkedinCallback from './pages/auth/linkedin_callback';
import EchoMailPage from './pages/plugins-page/EchoMailPage';
import AccountPage from './pages/account-page/AccountPage';
import ReportsPage from './pages/reports-page/ReportsPage';
import PlansPage from './pages/plans-page/PlansPage';
import AdminPage from './pages/admin-page/AdminPage';
import ForgotPassPage from './pages/forgotpass-page/ForgotPassPage';
import UserGuidePage from './pages/user-guide-page/UserGuidePage';

function AppRoutesShell({ children }) {
  const { pathname } = useLocation();
  const isChatHome = pathname === '/';

  return (
    <div
      className={cn(
        'flex w-full min-h-0 flex-col',
        isChatHome ? 'flex-1 overflow-hidden' : 'min-h-screen'
      )}
    >
      {children}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppRoutesShell>
        <ChatArtifactProvider>
          <MainLayout>
            <Routes>
          {'fix the paths to go back to app if authenticated Call it authenticated route'}
          <Route path="/" element={<ChatPage />} />
          <Route path="/forgot-password" element={<ForgotPassPage />} />
          <Route path="/signup" element={<AuthRoute><SignupPage /></AuthRoute>} />
          <Route path="/confirm" element={<AuthRoute><ConfirmPage /></AuthRoute>} />
          <Route path="/login" element={<AuthRoute><LoginPage /></AuthRoute>} />
          <Route path="/plans" element={<ProtectedRoute><PlansPage /></ProtectedRoute>} />
          <Route path="plugins" element={<ProtectedRoute><PluginsPage /></ProtectedRoute>} />
          <Route path="plugins/echomail" element={<ProtectedRoute><EchoMailPage /></ProtectedRoute>} />
          <Route path="channels" element={<ProtectedRoute><ChannelsPage /></ProtectedRoute>} />
          <Route path="reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
          <Route
            path="admin"
            element={
              <ProtectedRoute requiredRoles={['admin','superadmin']}>
                <AdminPage />
                </ProtectedRoute>
            }
          />
          <Route path="account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
          <Route path="user-guide" element={<ProtectedRoute><UserGuidePage /></ProtectedRoute>} />
          <Route index element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
          <Route path="/auth/google/callback" element={<ProtectedRoute><GoogleCallback /></ProtectedRoute>} />
          <Route path="/auth/meta/callback" element={<ProtectedRoute><MetaCallback /></ProtectedRoute>} />
          <Route path="/auth/linkedin/callback" element={<ProtectedRoute><LinkedinCallback /></ProtectedRoute>} />
            </Routes>
          </MainLayout>
        </ChatArtifactProvider>
      </AppRoutesShell>
    </Router>
  );
}

export default App;
